module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_7005.a03191e4.png";